// This is to integrate global button styles for wordpress rich text editor updates.

import { css } from 'styled-components'
import size from './size'

export const generalVideoBlog = Object.entries(size).map(
  ([key, value]) => css`
    .video-block-${key} {
      max-width: ${value}%;
      & iframe {
        width: 100%;
        max-width: 100%;
      }
    }
  `
)
